import { render, staticRenderFns } from "./error-illustration.vue?vue&type=template&id=2d282849&"
import script from "./error-illustration.vue?vue&type=script&lang=js&"
export * from "./error-illustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports